
import { useEffect } from 'react';
import posthog from 'posthog-js';
import { useSession } from '@supabase/auth-helpers-react';
import { usePostHogAnalytics } from './usePostHogAnalytics';

export const usePostHogSurveys = () => {
  const session = useSession();
  const { identifyUser } = usePostHogAnalytics();

  useEffect(() => {
    if (session?.user && posthog.__loaded) {
      // Identify the user with PostHog
      identifyUser(session.user.id, {
        email: session.user.email,
        user_id: session.user.id,
      });
    }
  }, [session, identifyUser]);

  // Function to trigger a feedback survey
  const triggerFeedbackSurvey = (surveyType: 'general' | 'feature' | 'satisfaction' = 'general') => {
    if (posthog.__loaded) {
      // This will show surveys that you've configured in PostHog dashboard
      posthog.getFeatureFlag('show-feedback-survey') && posthog.capture('survey_triggered', {
        survey_type: surveyType,
        user_id: session?.user?.id
      });
    }
  };

  // Function to show a quick NPS survey
  const showNPSSurvey = () => {
    if (posthog.__loaded) {
      posthog.capture('nps_survey_requested', {
        user_id: session?.user?.id
      });
    }
  };

  return {
    triggerFeedbackSurvey,
    showNPSSurvey,
    isUserIdentified: !!session?.user && posthog.__loaded
  };
};
